export const orContentMediaBlockMockData = [
  {
    title: 'Come see for yourself',
    description:
      'Step inside a Design Center or Model Home to experience the craftsmanship and get support for your custom home journey.',
    link: {
      href: '#',
      label: 'Learn More',
    },
  },
];
